<nz-layout>
    <nz-content>
        <router-outlet></router-outlet>
    </nz-content>
</nz-layout>



